import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {ServerResponse} from "../../types/leave-review/leaveReviewSchema";
import {setSocials} from "../../slice/leave-review/leaveReviewSlice";

export const getLeaveReview = createAsyncThunk(
    "leaveReview",
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.get<ServerResponse>("/api/profile/review", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }
            if (response.data.success) {
                thunkAPI.dispatch(setSocials(response.data.socials));
            }
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
